import {
  dependencyIssue,
  describeSeconds,
  mailboxErrorText,
} from "./mailboxesSupport";
import { Notice } from "./Notice";

/**
 * Ошибка запроса к почтовым операциям.
 *
 * Ограничение частоты (429) и недоступность зависимости (503) — разные
 * состояния с разным действием человека, поэтому у каждого свой заголовок,
 * цвет и подсказка. Остальные ошибки показываются обычным сообщением формы.
 */
export function MailboxNotice({
  error,
  fallback,
  onRetry,
  retrying = false,
}: {
  error: unknown;
  fallback: string;
  /** Есть — рядом с сообщением появляется кнопка повтора. */
  onRetry?: () => void;
  retrying?: boolean;
}) {
  const issue = dependencyIssue(error);

  if (issue === null) {
    return <Notice>{mailboxErrorText(error, fallback)}</Notice>;
  }

  const rateLimited = issue.kind === "rate-limited";
  const wait =
    issue.retryAfterSeconds === null
      ? null
      : describeSeconds(issue.retryAfterSeconds);

  return (
    <div
      className={`mb-notice mb-notice--${issue.kind}`}
      role="alert"
      data-kind={issue.kind}
    >
      <div className="mb-notice__body">
        <strong className="mb-notice__title">
          {rateLimited
            ? "Слишком много запросов"
            : issue.source === "mailbox"
              ? "Ящик недоступен"
              : "Сервис временно недоступен"}
        </strong>
        <p>
          {rateLimited
            ? `Почтовые операции ограничены по частоте.${wait === null ? " Подождите немного" : ` Повторите через ${wait}`} — ничего не потеряно.`
            : issue.source === "mailbox"
              ? "Core не смог получить доступ к ящику: чаще всего ссылка на секрет не найдена на сервере (переменная окружения или Docker secret не заданы) либо почтовый адаптер отключён. Проверьте ссылку в настройках ящика или обратитесь к администратору сервера. Настройки не менялись."
              : "Почтовый сервер или один из сервисов ERP сейчас не отвечает. Настройки не менялись; повторите, когда сервис восстановится."}
        </p>
      </div>
      {onRetry === undefined ? null : (
        <button
          type="button"
          className="button button--secondary button--compact"
          disabled={retrying}
          onClick={onRetry}
        >
          {retrying ? "Повторяем…" : "Повторить"}
        </button>
      )}
    </div>
  );
}
